export function flattenStudentFromApi(entity: Record<string, unknown> | null): Record<string, unknown> {
  if (!entity) {
    return {};
  }
  const p = entity.profile as Record<string, unknown> | undefined;
  const base: Record<string, unknown> = {
    name: entity.name ?? "",
    phone: entity.phone ?? "",
    image: entity.image ?? "",
    is_active: entity.is_active ?? true,
  };
  if (!p) {
    return {
      ...base,
      stage_id: 0,
      parent_phone: "",
      gender: "male",
      date_of_birth: "",
      grade_id: 0,
    };
  }
  return {
    ...base,
    stage_id: Number(p.stage_id) || 0,
    parent_phone: p.parent_phone ?? "",
    gender: (p.gender as string) || "male",
    date_of_birth: (p.date_of_birth as string) || "",
    grade_id: Number(p.grade_id) || 0,
  };
}

export function buildStudentPayload(
  form: Record<string, unknown>,
  _stageSlugById?: Map<number, string>
): Record<string, unknown> {
  const stageId = Number(form.stage_id);

  const parentPhone = form.parent_phone;
  const base: Record<string, unknown> = {
    name: form.name,
    phone: form.phone,
    image: form.image === "" || form.image === undefined ? null : form.image,
    is_active: form.is_active,
    stage_id: stageId,
    parent_phone:
      parentPhone === "" || parentPhone === undefined || parentPhone === null ? null : parentPhone,
    gender: form.gender,
    date_of_birth: form.date_of_birth,
  };

  return {
    ...base,
    grade_id: Number(form.grade_id),
  };
}

export function studentAcademicSummary(row: Record<string, unknown>, isArabic: boolean): string {
  const p = row.profile as Record<string, unknown> | undefined;
  if (!p) return "-";
  const stage = p.stage as { name?: string } | undefined;
  const g = p.grade as { name?: string } | undefined;
  return g?.name || stage?.name || (isArabic ? "غير محدد" : "Not specified");
}

export function studentStageLabel(row: Record<string, unknown>): string {
  const p = row.profile as Record<string, unknown> | undefined;
  const stage = p?.stage as { name?: string } | undefined;
  return stage?.name || "-";
}
